/* import __COLOCATED_TEMPLATE__ from './company-selector.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';
import type CompanySummary from 'embercom/objects/inbox/company-summary';

interface Signature {
  Element: HTMLElement;
  Args: { company: CompanySummary | undefined; onSelect: (company: CompanySummary) => void };
}

const CompanySelector = templateOnlyComponent<Signature>();
export default CompanySelector;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Search::CompanySelector': typeof CompanySelector;
  }
}
